export const LOGO_URL =
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_beauty-confidence-co-2/artifacts/qy8syx60_FullLogo%20%283%29%20ariel.png";

export const SERVICE_CATEGORIES = [
    {
        id: "injectables",
        label: "Injectables",
        number: "01",
        blurb: "Refined enhancement. Natural definition.",
        items: [
            {
                name: "Neuromodulators",
                price: "$13",
                unit: "per unit",
                aka: "Botox · Xeomin",
                description:
                    "Soften expression lines and help prevent new ones from forming for a refreshed, natural look.",
            },
            {
                name: "Dermal Fillers",
                price: "$700+",
                unit: "per syringe",
                note: "starting at",
                aka: "Lip · Cheek · Chin · Jawline",
                description:
                    "Restore volume, enhance contours, soften lines with treatments that create balanced, natural-looking results.",
            },
        ],
    },
    {
        id: "biostimulators",
        label: "Regenerative",
        number: "02",
        blurb: "Collagen restoration. Structural renewal.",
        items: [
            {
                name: "PRP — Platelet Rich Plasma",
                price: "Consultation",
                unit: "pricing on request",
                description:
                    "PRP uses your body's own platelets to support collagen and natural renewal, helping improve texture, tone, and glow. When paired with microneedling, it can further enhance results for smoother-looking, refreshed skin.",
            },
            {
                name: "PRF — Platelet Rich Fibrin",
                price: "Consultation",
                unit: "pricing on request",
                description:
                    "A natural treatment that uses your own healing factors to support skin and hair restoration.",
            },
            {
                name: "Sculptra",
                price: "$750+",
                unit: "per vial",
                note: "starting at",
                description:
                    "A collagen-stimulating biostimulator that gradually restores volume and structure over time for a naturally refreshed appearance.",
            },
            {
                name: "Radiesse",
                price: "$800+",
                unit: "per syringe",
                note: "starting at",
                description:
                    "A dual-action biostimulator that lifts and contours while stimulating your body's own collagen for lasting, natural results.",
            },
        ],
    },
    {
        id: "skin",
        label: "Skin Rejuvenation",
        number: "03",
        blurb: "Luminous, restored, renewed skin.",
        items: [
            {
                name: "Microneedling",
                price: "$399",
                description:
                    "Stimulate natural collagen to improve texture, soften the look of fine lines and scars, and reveal smoother, healthier-looking skin.",
            },
            {
                name: "Microneedling with PRP / PRF",
                price: "$499",
                description:
                    "Enhance results using your body's own healing factors to support collagen and promote a radiant complexion.",
            },
            {
                name: "PDO Threads — Skin",
                price: "$399+",
                note: "starting at",
                description:
                    "Stimulate collagen to improve firmness and texture, with a subtle, gradual lift.",
            },
            {
                name: "PDO Threads — Hair Restoration",
                price: "$899+",
                note: "starting at",
                description:
                    "Designed to support healthier-looking hair by stimulating the scalp and natural processes.",
            },
            {
                name: "VI Peel",
                price: "$349+",
                note: "starting at",
                description:
                    "A medical-grade chemical peel that helps improve skin tone, texture, acne, and the appearance of fine lines, revealing a brighter, smoother complexion. Your provider will recommend the right option for your skin goals.",
            },
            {
                name: "Hydrodermabrasion Facial",
                price: "$249",
                description:
                    "A deep-cleansing facial that gently exfoliates and infuses nourishing serums for smoother, brighter, more hydrated skin.",
            },
            {
                name: "Customized Facial",
                price: "$179",
                description:
                    "Tailored to your skin's unique needs to restore balance and glow.",
            },
        ],
    },
    {
        id: "iv",
        label: "IV Hydration Therapy",
        number: "04",
        blurb:
            "Restore hydration, replenish vitamins, support energy and recovery. Nurse practitioner supervised, customized to your goals.",
        items: [
            {
                name: "Quench IV",
                price: "$199",
                description:
                    "Deep cellular hydration to replenish fluids and electrolytes after travel, heat, or long days.",
            },
            {
                name: "Myers' Cocktail",
                price: "$249",
                description:
                    "A classic blend of vitamins and minerals to support overall wellness, immunity, and daily vitality.",
            },
            {
                name: "Immunity IV",
                price: "$229",
                description:
                    "High-dose vitamin C, zinc, and B-complex to reinforce your immune system when you need it most.",
            },
            {
                name: "Get Up and Go IV",
                price: "$229",
                description:
                    "An energizing formula to support metabolism, focus, and physical recovery.",
            },
            {
                name: "Inner Beauty IV",
                price: "$249",
                description:
                    "A radiance-focused blend to support skin, hair, and nail health from the inside out.",
            },
            {
                name: "Alleviate IV",
                price: "$249",
                description:
                    "A soothing infusion formulated to help ease monthly discomfort and support balance.",
            },
        ],
    },
    {
        id: "additional",
        label: "Additional Services",
        number: "05",
        blurb: "Personalized medical care beyond the surface.",
        items: [
            {
                name: "Weight Management",
                price: "Consultation",
                note: "consultation required",
                description:
                    "Personalized medical weight management focused on sustainable, healthy results.",
            },
            {
                name: "Sexual Wellness",
                price: "Consultation",
                note: "consultation required",
                description:
                    "Private, compassionate care for men and women to address common concerns and support overall well-being.",
            },
            {
                name: "Hyperhidrosis Treatment",
                price: "Consultation",
                note: "consultation required",
                description:
                    "Discreet, evidence-informed care to reduce excessive sweating and restore everyday confidence.",
            },
            {
                name: "Additional Aesthetic Services",
                price: "Coming Soon",
                note: "in development",
                description:
                    "New treatments are added thoughtfully. Ask us what's coming next — we'd love to tell you.",
            },
        ],
    },
];

// Universal closing line shown beneath every category's item list.
export const SERVICES_FOOTER_NOTE =
    "Every treatment begins with a personalized consultation to develop a plan tailored to your goals and overall wellness.";


export const MANIFESTO_CHAPTERS = [
    {
        n: "01",
        title: "The Philosophy",
        body: "We believe beauty and wellness go hand in hand. Every treatment plan is authored around you — because no two clients are alike.",
    },
    {
        n: "02",
        title: "The Practice",
        body: "Owned and operated by a board-certified family nurse practitioner. Safe, compassionate, and evidence-informed care with a steady, personalized approach.",
    },
    {
        n: "03",
        title: "The Promise",
        body: "Natural-looking results. Honest guidance. A conversation before a procedure — always. Your journey begins with a complimentary consultation.",
    },
];

export const TESTIMONIALS = [
    {
        quote: "Crystal took time to understand what I actually wanted. The result feels like me — only more rested.",
        author: "Alexis R.",
        role: "Client, Injectables",
    },
    {
        quote: "The most thoughtful consultation I've ever had. Zero pressure. Real expertise.",
        author: "Danielle P.",
        role: "Client, IV Therapy",
    },
    {
        quote: "My skin has never looked this alive. This is care, not a transaction.",
        author: "Monica L.",
        role: "Client, Microneedling",
    },
];
